import {
    Box,
    Button,
    FormControl,
    TextField,
    Typography,
    Grid
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";
import BasicDialog from "../../../components/base/BasicDialog/BasicDialog";
import { useState } from "react";
import SelectFieldService from "../../../services/selectFieldService";
import TextFieldFormControl from "../../field/TextFieldFormControl";
import { fontWeight } from "@mui/system";
import { useAnonymizeCustomer } from "../../../services/customersService";
import { useToasts } from "../../../hooks/useToasts";
import toast from "react-hot-toast"
import { SnackbarSuccess } from "../../../components/base/SnackbarAlert/SnackbarSuccess";


export default function ConfirmCustomerAnonymizationDialog({ open, onClose, customerId, dialogTitle}) {
    const { t } = useTranslation();
    const { onFormErrors, onServerError } = useToasts();
    const { mutate: anonymizeCustomer, isPending } = useAnonymizeCustomer({
        onSuccess: (data, variables, context) => {
            toast.custom(
                () => <SnackbarSuccess message={t("successfullyAnonymized")} />,
                {
                    position: "bottom-right",
                },
            );
            onClose()
        },
        onError: (error) => {
            onServerError(error);
        },
    });
    const [comment, setComment] = useState()
    const anonymizationInfo = (
        <div style={{fontSize: "17px"}}>
            {"Czy na pewno chcesz zanonimizować klienta"}
        </div> 
    )

    
    const onSubmit = () => {
        anonymizeCustomer({
            customer_id: customerId,
            comment: comment
        })
    };

    return (
        <BasicDialog
            open={open}
            onClose={onClose}
            title={dialogTitle || t("clients.PersonClausesDialog.ConfirmCustomerAnonymizationDialogTitle")}
            maxWidth="sm"
            titleSx={{textAlign: "center"}}
            showBottomCloseButton={false}
            showDialogActions={false}
        >
                <Grid container>
                    <Grid item xs={12}>
                        <Typography 
                            // sx={{fontWeight: "bold"}}

                        >
                            {anonymizationInfo}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TextFieldFormControl
                            sx={{marginBlock: 2}}
                            value={comment}
                            label={`${t("clients.PersonClausesDialog.table.comment")}*`}
                            onChange={(e)=>{setComment(e.target.value)}}
                            multiline
                            rows={4}
                        />
                    </Grid>
                    <Grid
                        item 
                        xs={12}
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={3}
                    >
                        <Grid item xs={6} textAlign={"right"}>
                            <LoadingButton
                                style={{ minWidth: "100px" }}
                                variant="contained"
                                size="small"
                                onClick={onSubmit}
                                color={"success"}
                                loading={isPending}
                                disabled={!comment || isPending}
                            >
                                {t("true")}
                            </LoadingButton>
                        </Grid>
                        <Grid item xs={6} textAlign={"left"}>
                            <Button
                                color={"error"}
                                style={{ minWidth: "100px" }}
                                variant="contained"
                                size="small"
                                onClick={onClose}
                                disabled={isPending}
                            >
                                {t("false")}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
        </BasicDialog>
    );
}